<template>
	<article class="manage__splash-submit--page">
		<SplashController />
	</article>
</template>

<script>
	import SplashController from '@/components/manage/SplashController.vue';

	export default {
		name: 'SplashSubmit',
		components: { SplashController },
		created() {
			this.$store.commit('splash/changeValues', [
				{ key: 'id', value: null },
			]);
			this.$store.commit('splash/init');
		},
		mounted() {
			this.$store.commit('toggleSpinner', false);
		},
	};
</script>
